module.exports = __webpack_public_path__ + "static/media/400077_01.85dd8655.png";